import { useState } from 'react';

const NAV_LINKS = [
  { key: 'tagwall', label: '话题墙' },
  { key: 'hot', label: '热搜榜' },
  { key: 'feed', label: '最新瓜讯' },
  { key: 'track', label: '事件追踪' },
  { key: 'faq', label: '常见问答' },
];

export default function Header() {
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    // 静态展示：仅展示提示，不接接口
    setKeyword('');
  };

  const goAnchor = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex shrink-0 cursor-pointer items-center gap-2"
          aria-label="回到顶部"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-lg" aria-hidden="true" />
          </span>
          <span className="text-xl tracking-wide text-foreground-950">婚内出轨</span>
        </button>

        <nav className="hidden items-center gap-1 md:flex" aria-label="站点导航">
          {NAV_LINKS.map((l) => (
            <button
              key={l.key}
              type="button"
              onClick={() => goAnchor(l.key)}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={handleSearch}
            className="hidden items-center overflow-hidden rounded-full border border-background-300/70 bg-background-50 pl-3 lg:flex"
          >
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜人物、事件或关键词"
              className="h-9 w-40 bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 transition-all focus:w-52"
              aria-label="搜索"
            />
          </form>
          <span className="hidden h-6 w-px bg-background-300 sm:block" />
          <span className="hidden items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1.5 text-xs text-accent-900 sm:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            今日瓜讯 12+
          </span>
          <button
            type="button"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-700 hover:bg-secondary-100 md:hidden"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="展开菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-300/70 bg-background-50 px-3">
            <i className="ri-search-line text-sm text-foreground-500" aria-hidden="true" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜人物、事件或关键词"
              className="h-9 w-full bg-transparent text-sm text-foreground-900 outline-none"
              aria-label="搜索"
            />
          </div>
          <div className="flex flex-wrap gap-1.5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.key}
                type="button"
                onClick={() => goAnchor(l.key)}
                className="cursor-pointer whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-sm text-foreground-800 hover:bg-secondary-200"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}